export default "__VITE_ASSET__157180a0__"